<template>
    <section>
        <div class="redirect">Redirecting...</div>
    </section>
</template>

<style scoped>
.redirect{
    size: 12px!important;
    text-align: center;
    font-weight: 900;
    padding-top: 50px;
    padding-bottom: 300px;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    created() {
        this.logActivity({type: "info", message: "Switch back attempt - user:" + this.userEmail + ", authorized-user: " + this.authorized_user.user});
        if(this.authorized_user && this.authorized_user.user && this.authorized_user.session){
            this.setUser(this.authorized_user.user);
            this.setSession(this.authorized_user.session);
            this.clearSessionDetails();
            this.clearAuthorizedUser();
            setTimeout(() => {
                window.location.href = "/account";
            }, 100);
        } else {
            this.$router.push("/account");
        }
    },
    computed: {
        ...mapGetters({
            authorized_user: 'user/authorized_user',
            userEmail: 'user/user',
        })
    },
    methods: {
        ...mapActions({
            setUser: 'user/setUser',
            setSession: 'user/setSession',
            clearAuthorizedUser: 'user/clearAuthorizedUser',
            clearSessionDetails: 'user/clearSessionDetails',
            logActivity: 'log/logActivity',
        }),
    }
};
</script>
